import React from "react";
import { CloseRedCircle } from "../../../styles/img/svg/CloseRedCircle";
import {
  commonConstants,
  schedulePaymentsConstants,
} from "../../../_redux/_constants";
import moment from "moment";
import { getScheduleFrequencyLabel } from "../../../_helpers/schedulePayment.helper";

export const UiScheduleSummary = ({
  scheduleSummary,
  onStopAllClick,
  isStopLoading,
}) => {
  return (
    <div className="df-schedule-summary-card">
      <div className="df-schedule-summary-card__row">
        <span>Frequency:</span>
        <span>{getScheduleFrequencyLabel(scheduleSummary?.frequency)}</span>
      </div>

      <div className="df-schedule-summary-card__row">
        <span>Total No of Payments:</span>
        <span>{scheduleSummary?.noOfPayments}</span>
      </div>

      <div className="df-schedule-summary-card__row">
        <span>Active Payments:</span>
        <span>{scheduleSummary?.activeTransactions}</span>
      </div>

      <div className="df-schedule-summary-card__row">
        <span>Failed Payments:</span>
        <span>{scheduleSummary?.failedTransactions}</span>
      </div>

      <div className="df-schedule-summary-card__row">
        <span>Success Payments:</span>
        <span>{scheduleSummary?.successTransactions}</span>
      </div>

      <div className="df-schedule-summary-card__row">
        <span>Stopped Payments:</span>
        <span>{scheduleSummary?.stoppedTransactions}</span>
      </div>

      <div className="df-schedule-summary-card__row">
        <span>Schedule Start Date:</span>
        <span>
          {scheduleSummary?.startDate &&
            moment(scheduleSummary?.startDate).format(
              commonConstants.COMMON_DATE_FORMAT_DD_MM_YYYY,
            )}
        </span>
      </div>

      {scheduleSummary?.endDate && (
        <div className="df-schedule-summary-card__row">
          <span>Schedule End Date:</span>
          <span>
            {scheduleSummary?.endDate &&
              moment(scheduleSummary?.endDate).format(
                commonConstants.COMMON_DATE_FORMAT_DD_MM_YYYY,
              )}
          </span>
        </div>
      )}
      <div className="df-schedule-summary-card__divider" />

      {scheduleSummary?.recurringTxnStatus ===
        schedulePaymentsConstants.SCHEDULE_PAYMENTS_RECURRING_TXN_STATUS_ACTIVE && (
        <button
          type="button"
          className="df-schedule-summary-card__stop-btn"
          onClick={onStopAllClick}
          disabled={isStopLoading}
        >
          <span className="df-schedule-summary-card__stop-icon">
            <CloseRedCircle />
          </span>

          <span>Stop All Schedules</span>
        </button>
      )}
    </div>
  );
};
